import { render, staticRenderFns } from "./CriminalRecord.vue?vue&type=template&id=7560a2c1&"
import script from "./CriminalRecord.vue?vue&type=script&lang=js&"
export * from "./CriminalRecord.vue?vue&type=script&lang=js&"
import style0 from "./CriminalRecord.vue?vue&type=style&index=0&id=7560a2c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports